var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("vue-cal", {
        staticStyle: { height: "800px" },
        attrs: {
          time: false,
          events: _vm.events,
          locale: _vm.$i18n.locale,
          "active-view": "month",
          "events-on-month-view": "short",
          "on-event-click": _vm.onEventClick,
          "on-event-dblclick": _vm.onEventDoubleClick
        },
        on: { "view-change": _vm.fetchEvents }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }